import styled from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';
import { SIDE_MENU_BREAKPOINTS } from '@/shared/libs/side-menu-breakpoints';
import { SIDE_MENU_ATTRIBUTE } from '@/shared/libs/side-menu-attribute';

export const ProfileWrapper = styled.div`
  ${WRAPPER};
  display: flex;
  gap: 24px;
`;
export const ProfileContainer = styled.div`
  border-top: 1px solid #1b202d;
  padding-top: 20px;

  @media (max-width: 768px) {
    padding-top: 0;
  }
`;

export const MobileMenuWrapper = styled.div<{ $flexMain?: boolean }>`
  @media (orientation: portrait) {
    /* padding-bottom: 50px; */
  }
  @media (max-width: 1024px) and (orientation: landscape) {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100dvh;
  }
  ${({ $flexMain }) =>
    $flexMain &&
    `
      @media (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        height: 100dvh;
        padding-right: 0;
        box-sizing: border-box;
      }
    `};
`;
export const ContentWrapper = styled.div<{
  $withoutMenu?: boolean;
  $flexMain?: boolean;
}>`
  @media (orientation: portrait) {
    ${({ $withoutMenu }) =>
      $withoutMenu &&
      `
    padding-bottom: 0;
  `}
  }
  @media (max-width: 1024px) and (orientation: landscape) {
    width: 100%;

    display: flex;
    flex-direction: column;
    height: 100%;
  }
  ${({ $flexMain }) =>
    $flexMain &&
    `
    @media (max-width: 1024px) {
      display: flex;
      flex-direction: column;
      height: 100%;
      box-sizing: border-box;
      padding-bottom: 0;
    }
    `}
`;
export const HeaderSlot = styled.div<{ $hideInLandscape: boolean }>`
  display: contents;

  ${({ $hideInLandscape }) =>
    $hideInLandscape &&
    `
    @media (max-width: 1023.98px) and (orientation: landscape) {
      display: none;
    }
  `}
`;
export const UnderHeaderWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  overflow-y: hidden;

  @media (orientation: landscape) {
    flex-direction: row-reverse;
    min-height: 266px;
    justify-content: flex-end;
    flex: 1;
    padding-right: var(--app-safe-area-right);
    box-sizing: border-box;
  }
  @media (orientation: portrait) {
    flex-direction: column;
    flex: 1;
  }
`;
export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  @media (min-width: 769px) {
    //padding: 0 18px;
  }
`;
export const MainWrapper = styled.main<{ $flexMain?: boolean }>`
  @media (max-width: 1024px) and (orientation: landscape) {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    flex: none;
  }

  ${({ $flexMain }) =>
    $flexMain &&
    `
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    width: 100%;
    align-items: center;
  `}
`;

const menuReservedWidthRules = `
  width: 100%;
  margin-left: auto;

  @media (min-width: ${SIDE_MENU_BREAKPOINTS.mobile}px) {
    width: calc(100% - 70px);
    margin-left: 70px;
  }

  @media (min-width: ${SIDE_MENU_BREAKPOINTS.expanded}px) {
    width: calc(100% - 320px);
    margin-left: 320px;
  }

  @media (min-width: ${SIDE_MENU_BREAKPOINTS.mobile}px) {
    html[${SIDE_MENU_ATTRIBUTE}='true'] & {
      width: calc(100% - 320px) !important;
      margin-left: 320px !important;
    }

    html[${SIDE_MENU_ATTRIBUTE}='false'] & {
      width: calc(100% - 70px) !important;
      margin-left: 70px !important;
    }
  }
`;

export const ContentWrapperLayout = styled.div`
  height: 100%;
  ${menuReservedWidthRules}

  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;
export const FooterWrapper = styled.div`
  ${menuReservedWidthRules}

  z-index: 10;
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;
